import { getValidToken } from "./getValidToken";

async function fetchWithToken(url, options = {}, forceRefresh = false) {
  const token = await getValidToken({ forceRefresh });

  const headers = {
    ...(options.headers || {}),
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return fetch(url, {
    ...options,
    headers,
  });
}

async function buildErrorMessage(response) {
  let errorMessage = `Error: ${response.status} ${response.statusText}`;
  try {
    const errorData = await response.json();
    errorMessage = errorData?.message || errorData?.error || errorMessage;
  } catch {
    // Ignore JSON parse error
  }
  return errorMessage;
}

export async function authenticatedFetch(url, options = {}) {
  let response = await fetchWithToken(url, options);

  if (response.status === 401) {
    // Access token was rejected — force-refresh once and retry the request
    response = await fetchWithToken(url, options, true);
  }

  if (!response.ok) {
    throw new Error(await buildErrorMessage(response));
  }

  return response.json();
}
